import {postRequest} from "../libs/AxiosService.util";

export async function serviceCandidateDocumentTrackerList(params) {
    return await postRequest('onboarding/sent/history', params);
}